import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VantaResultExportType } from '../enums/vanta-result-export-type';
import { IResultFormattedItem } from '../interfaces/result-formatted-item';
import { ISearchParams } from '../interfaces/search-params';
import { SearchResultItem } from '../interfaces/search-result-item';
import { timeout } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    constructor(private httpClient: HttpClient) { }

    public doSearchVantaShots(params: ISearchParams): Observable<Array<SearchResultItem>> {
        let url = `/api/datamanagement/deviceshots?begindate=${params.beginDate.toISOString()}
        &enddate=${params.endDate.toISOString()}&pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`;

        if (params.serialNumber) {
            url += `&serialnumber=${params.serialNumber}`;
        }

        if (params.method) {
            url += `&method=${params.method}`;
        }
        return this.httpClient.get<Array<SearchResultItem>>(url);
    }

    public getVantaShot(resultId: string): Observable<IResultFormattedItem> {
        return this.httpClient.get<IResultFormattedItem>(`/api/datamanagement/deviceshot?testId=${resultId}`);
    }

    public exportVantaShot(resultId: string[], resultExportType: VantaResultExportType): Observable<Blob> {
         const requestOptions: object = {
             responseType: 'blob'
           };
        return this.httpClient.put<Blob>(`/api/datamanagement/deviceshot/export?shotResultType=${resultExportType.toString()}`, 
            resultId, requestOptions).pipe(timeout(300000));
    }

    public deleteVantaShots(resultIds: string[]) {
        return this.httpClient.post('/api/datamanagement/deviceshots', resultIds);
    }
}
